module.exports = __webpack_public_path__ + "assets/san-francisco-tech-recruiters-2.db164a09.png";